/*
  R24 · Startseite: ruhiges Einblenden beim Scrollen (Owner 30.09.2026).
  Setzt html.r24-rv + [data-rv] + .is-in; das Aussehen steht in assets/r24-home-glass.css.
  Regeln: nichts ist ohne Skript versteckt; was beim Laden schon im Bild ist, erscheint sofort (kein Aufblitzen);
  „Bewegung reduzieren“ und fehlender IntersectionObserver = keine Animation; Staffelung höchstens 6 Stufen à 70 ms.
  Schienen (waagrecht) blenden als Ganzes ein — deren Karten tauscht assets/r24-motion.js aus.
*/
(function () {
  'use strict';
  var W = window, D = document;
  var SEL = [
    '.r24h-head', '.r24sr-head',
    '.r24h-cols > .r24h-col',
    '.r24h-cards:not(.r24h-cards--rail) > .r24h-card',
    '.r24h-cards--rail', '.r24sr-rail',
    '.r24mag__card',
    '.r24gs__panel', '.r24gs__cards > li',
    '.r24gf__head', '.r24gf__hero', '.r24gf__tiles > li',
    '.r24gt__head', '.r24gt__list > li',
    '.r24h-plp__card', '.r24h-nl', '.r24stl-wrap',
    '.r24aw__head', '.r24aw__grid > li', '.r24bt__intro', '.r24bt__ways > li'
  ].join(',');

  function start() {
    if (!('IntersectionObserver' in W)) return;
    try { if (W.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
    var els = [].slice.call(D.querySelectorAll('main ' + SEL.split(',').join(', main ')));
    if (!els.length) return;
    D.documentElement.classList.add('r24-rv');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    var vh = W.innerHeight || 800;
    els.forEach(function (el) {
      var sibs = [].slice.call(el.parentElement ? el.parentElement.children : []).filter(function (c) { return els.indexOf(c) > -1; });
      var i = Math.max(0, sibs.indexOf(el));
      el.style.setProperty('--rv-d', Math.min(i, 6) * 70 + 'ms');
      if (el.getBoundingClientRect().top < vh * 0.96) el.classList.add('is-in');
      el.setAttribute('data-rv', '');
      if (!el.classList.contains('is-in')) io.observe(el);
    });
    /* Sicherheit: was im oder über dem Bild liegt, erscheint immer — auch wenn der Observer einmal nicht meldet
       (Sprung per Anker/Zurück, schnelles Scrollen). Passiver Scroll-Abgleich, höchstens einmal je Bild. */
    var pend = false;
    function sweep() {
      pend = false; vh = W.innerHeight || vh; var left = 0;
      els.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        if (el.getBoundingClientRect().top < vh * 0.92) { el.classList.add('is-in'); io.unobserve(el); } else left++;
      });
      if (!left) { W.removeEventListener('scroll', onScroll); W.removeEventListener('resize', onScroll); }
    }
    function onScroll() { if (!pend) { pend = true; (W.requestAnimationFrame || setTimeout)(sweep, 16); } }
    W.addEventListener('scroll', onScroll, { passive: true });
    W.addEventListener('resize', onScroll, { passive: true });
    W.addEventListener('pageshow', sweep);
    setTimeout(sweep, 1500);
  }
  /* Fortschrittsleiste unter jeder waagrechten Schiene: Breite = sichtbarer Anteil, Lage = Scrollstand.
     Unabhängig von der Bewegungs-Einstellung (reine Orientierung, keine Animation nötig). */
  function progress() {
    [].slice.call(D.querySelectorAll('main .r24h-cards--rail, main .r24sr-rail')).forEach(function (rail) {
      if (rail.nextElementSibling && rail.nextElementSibling.classList.contains('r24hg-prog')) return;
      var bar = D.createElement('div'); bar.className = 'r24hg-prog'; bar.setAttribute('aria-hidden', 'true');
      var sp = D.createElement('span'); bar.appendChild(sp); rail.parentNode.insertBefore(bar, rail.nextSibling);
      var pend = false;
      function upd() {
        pend = false; var sw = rail.scrollWidth, cw = rail.clientWidth;
        if (sw <= cw + 4) { bar.hidden = true; return; }
        bar.hidden = false; var w = Math.max(12, cw / sw * 100), max = sw - cw;
        sp.style.setProperty('--pw', w + '%');
        sp.style.setProperty('--px', (max > 0 ? rail.scrollLeft / max : 0) * (100 / w * (100 - w)) + '%');
      }
      rail.addEventListener('scroll', function () { if (!pend) { pend = true; (W.requestAnimationFrame || setTimeout)(upd, 16); } }, { passive: true });
      W.addEventListener('resize', upd, { passive: true });
      upd(); setTimeout(upd, 1200);
    });
  }
  function boot() { progress(); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
})();
